<template>
    <b-container fluid class="p-0">
        <b-row>
            <b-col sm="12" class="mb-0 pb-0">
                <div>
                    <div class="row d-flex flex-row">
                        <div class="col-4 text-left">
                            <p class="mb-0">
                                <span class="">Modifier Group Name</span>
                            </p>
                            <p class="mb-0 text-muted">
                                <span>{{selectedModifierName}}</span>
                            </p>
                        </div>
                        <div class="col-4 text-left">
                            <p class="mb-0">
                                <span class="">Type</span>
                            </p>
                            <p class="mb-0 text-muted">
                                <span v-if="selectedModifierOptional === 1">Optional</span>
                                <span v-else>Required</span>
                            </p>
                        </div>
                        <div class="col-4 text-left">
                            <p class="mb-0">
                                <span class="">Rule</span>
                            </p>
                            <p class="mb-0 text-muted">
                                <span>{{selectedModifierChoiceOption}}</span>
                                <span class="mx-2">{{selectedModifierChoiceNumber}}</span>
                            </p>
                        </div>
                    </div>
                    <b-table-simple class="mt-3" striped borderless v-if="currentModifier.length">
                        <b-thead >
                            <b-tr class="bg-gray-300">
                                <b-th>Modifier Name</b-th>
                                <b-th>Comment</b-th>
                                <b-th>Add'l Price</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="item in currentModifier">
                                <b-td>
                                    <span>{{item.ModifierName}}</span>
                                    <span class="mx-3" v-if="AllowSecondLang && item.ModifierName_SecondLang !== ''">{{item.ModifierName_SecondLang}}</span>
                                </b-td>
                                <b-td>{{item.ModifierDesc}}</b-td>
                                <b-td>${{item.Price.toFixed(2)}}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <div>
                        <b-input-group prepend="Modifier Name" class="my-3">
                            <b-input v-model="model.ModifierName" name="ModifierName" v-validate="'required'"/>
                        </b-input-group>
                        <b-input-group v-if="AllowSecondLang" prepend="Second Language Modifier name" class="my-3">
                            <b-input name="ModifierName_SecondLang" v-model="model.ModifierName_SecondLang"/>
                        </b-input-group>
                        <b-input-group prepend="Comment" class="my-3">
                            <b-input v-model="model.ModifiertDESC" name="Comment"/>
                        </b-input-group>
                        <b-input-group prepend="Add'l Price ($)" class="my-3">
                            <b-input v-model="model.Price" type="number" name="Add'l Price" v-validate="'decimal|min_value:0'"/>
                        </b-input-group>
                        <b-alert :show="errors.any()" variant="danger" class="px-4 my-3">
                            <ul class="m-0 px-1">
                                <li v-for="err in errors.all()" :key="err">{{err}}</li>
                            </ul>
                        </b-alert>

                        <b-row class="flex-grow-1">
                            <b-col cols="4">
                                <b-btn variant="warning" block class="text-nowrap" :disabled="loading" @click="addNewModifierToCategory">
                                    <span v-if="!loading">Add Modifier</span>
                                    <font-awesome-icon v-else spin icon="circle-notch" class="align-middle"/>
                                </b-btn>
                            </b-col>
                            <b-col cols="4">
                                <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" :disabled="progressing" @click="closeModifierOption">
                                    Cancel
                                </b-btn>
                            </b-col>
                            <b-col cols="4">
                                <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="closeModifierOption">
                                    Save & Exit
                                </b-btn>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import Multiselect from '../shared/multiselect'
    export default {
        name: "addModifierOption",
        components: {
            Multiselect
        },
        props: {
            AllowSecondLang: {
                required: false
            },
            newAddedCategory: {
                required: true
            },
            selectedModifierName: {
                required: true
            },
            selectedModifierOptional: {
                required: true
            },
            selectedModifierChoiceNumber: {
                required: true
            },
            selectedModifierChoiceOption: {
                required: true
            },
            modeType: {
                required: true
            }
        },
        data () {
            return {
                model: {
                    Price: null,
                    ModifiertDESC: null,
                    ModifierName: null,
                    ModifierName_SecondLang: '',
                },
                Modifiers: [],
                currentModifier: [],
                editMode: false,
                loading: false,
                insert: false
            }
        },
        mounted() {
            this.getCurrentModifer()
        },
        methods: {
            getCurrentModifer () {
                //get currnet modifier option for selected modifer group
                let model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    CategoryID: this.newAddedCategory,
                    ModifierID: -1,
                    ModifierType: this.modeType
                }
                return this.$api.getRestaurant.GetRestaurantModifier(model).then(res => {
                    if (res.success) {
                        let results = res.results.RestaurantMidifierAll
                        this.currentModifier = results.map((item => ({...item})))
                    }
                })
            },
            addNewModifierToCategory () {
                // add new  modifier and connect this to the modifier group
                this.$validator.validateAll().then(res => {
                    if (res) {
                        let model = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            ModifierCategoryID: this.newAddedCategory,
                            ModifierType: this.modeType,
                            ModifierName: this.model.ModifierName,
                            ModifiertDESC: this.model.ModifiertDESC,
                            ModifierName_SecondLang: this.model.ModifierName_SecondLang.trim(),
                            Price : this.model.Price
                        }
                        this.loading = true
                        this.$api.getRestaurant.InsertModifier(model).then(res => {
                            if (res.success) {
                                this.loading = false
                                this.getCurrentModifer()
                                this.$validator.reset()
                                this.model.ModifierName = null
                                this.model.ModifiertDESC = null
                                this.model.ModifierName_SecondLang = ''
                                this.model.Price = null
                                // this.$emit('addModfier', false)
                            } else {
                                this.loading = false
                            }
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                })
            },
            closeModifierOption () {
                this.$emit('addModfier', false)
                this.$emit('closeModifierOption', false)
            }

        }
    }
</script>

<style scoped>

</style>
